import { z } from 'zod';
import { ModuleManifest } from '@momentum/shared';

export const HOT_POTATO_ID = 'hot-potato';

export const hotPotatoManifest = ModuleManifest.parse({
  id: HOT_POTATO_ID,
  version: '1.0.0',
  name: 'Hot Potato',
  description: 'A cooperative speaking round with a server-timed handover between every participant.',
  disposable: false,
  players: { min: 2, max: 6 },
  participation: 'cooperative',
  teams: null,
  voice: { scope: 'shared' },
  capabilities: { launchesChildren: false, childModuleIds: [], usesRandom: true, hasPrivateData: true, renderer: HOT_POTATO_ID },
  launchableFromLobby: true,
});

export const HotPotatoConfig = z.object({
  revealMs: z.number().int().min(100).max(30_000).default(1_500),
  countdownMs: z.number().int().min(100).max(10_000).default(3_000),
  turnMinMs: z.number().int().min(100).max(120_000).default(20_000),
  turnMaxMs: z.number().int().min(100).max(120_000).default(40_000),
  charredMs: z.number().int().min(100).max(30_000).default(9_000),
}).refine(config => config.turnMaxMs >= config.turnMinMs, { message: 'turnMaxMs must be at least turnMinMs' });
export type HotPotatoConfig = z.infer<typeof HotPotatoConfig>;

export const HotPotatoAction = z.object({ type: z.literal('ready') }).strict();
export type HotPotatoAction = z.infer<typeof HotPotatoAction>;

export const HotPotatoPhase = z.enum(['reveal', 'ready', 'countdown', 'speaking', 'charred', 'complete']);
export type HotPotatoPhase = z.infer<typeof HotPotatoPhase>;

export const HotPotatoParticipant = z.object({
  id: z.string(),
  displayName: z.string(),
  characterSlot: z.string().nullable(),
});
export type HotPotatoParticipant = z.infer<typeof HotPotatoParticipant>;

export const HotPotatoView = z.object({
  phase: HotPotatoPhase,
  prompt: z.object({ question: z.string(), followUp: z.string() }),
  participantIds: z.array(z.string()),
  participants: z.array(HotPotatoParticipant),
  readyIds: z.array(z.string()),
  holderId: z.string().nullable(),
  turnIndex: z.number().int().nonnegative(),
  completedIds: z.array(z.string()),
  heat: z.number().min(0).max(1),
  canReady: z.boolean(),
});
export type HotPotatoView = z.infer<typeof HotPotatoView>;

export const HotPotatoResultPayload = z.object({
  schema: z.literal(1),
  completedIds: z.array(z.string()),
  activityCompleted: z.boolean(),
});
export type HotPotatoResultPayload = z.infer<typeof HotPotatoResultPayload>;
